import React from 'react'
import IndustryForm from "../components/IndustryForm";
import TalentAppStep from "../components/TalentAppStep";

export default class IndustriesStep extends TalentAppStep
{
    static path = '/industry-experience';
    static LastUpdatedMethod = 'lastUpdatedIndustries';

    static HasRequirements = true;

    /**
     * The title shown on the form
     */
    static StepTitle = 'Industry Expertise';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = TB.trans('talent.industries.step_subtitle');
    /**
     * The start page info tile
     */
    static StepInfo = 'To match your industry experience with client needs, select what industries you’ve worked in. Add affiliated brands to showcase who you have worked with in the past';
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Expertise';

    /**
     * Show brief details for user
     */
     static ProfileSectionSummary = (user) => {
        if(!this.hasCompleted(user)) return false;
        return `${user.industries_worked?.length} Industries/${user.years_of_experience} Years`;
    };
    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        if (!user.validateIndustries()) {
            return this;
        }

        return false;
    };

    static hasCompleted(user) {
        return TB.filter(user.industries_worked || [], i => TB.isDefined(i?.id)).length > 0
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        if(!TB.filter(user.industries_worked || [], i => TB.isDefined(i?.id)).length) {
            await TB.sysAlert('talent.industries_step_industry_required')
            return false
        }
        return user.validateIndustries()
    };

    /**
     * @param {User} user
     * @returns {Object}
     */
    static reviewMapping(user) {
        let review = {};

        user.industries_worked.map((industry, index) => {
            review[`Industry #${index + 1}`] = {
                [TB.trans('talent.industries.review_mapping.project_type')]: industry.name,
                [TB.trans('talent.project_interests.review_mapping.years_exp')]: laravel.talent_scoring_options[industry.self_score]
            }
        })

        return review;
    }

    /**
     * Render the form
     *
     * @returns {Form}
     */
    renderFormFooter() {
        return (
            <div className="pb-6">

                {this.renderChildForm({
                    displayName: TB.trans('talent.industries.child_form.display_name'),
                    ChildFormComponent: IndustryForm,
                    formProps:{
                        industries_worked: {...this.props.user}.industries_worked || [],
                    },
                    userProp: 'industries_worked'
                })}
                {/*{this.renderChildForm({*/}
                {/*    displayName: 'Brand',*/}
                {/*    ChildFormComponent: BrandForm,*/}
                {/*    formProps:{*/}
                {/*        brands: {...this.props.user}.brands || [],*/}
                {/*    },*/}
                {/*    userProp: 'brands'*/}
                {/*})}*/}

            </div>
        );
    }

    /**
     * Are requirements completed?
     *
     * @returns boolean
     */
    isRequirementComplete() {
        return TB.filter(this.props.authUser.industries_worked || [], ind => !!ind?.id)?.length >= 1;
    }
    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return 'At least 1 industry expertise is required.';
    }
}